<div layout="row" layout-align="center center" flex layout-padding>
  <div ui-view="details" flex></div>
  <div ui-view="actions" ng-if="vm.isAdmin"></div>
</div>
